// Simple toast event bus (no external deps)
const listeners = new Set();

function emit(event) {
  for (const listener of listeners) {
    try {
      listener(event);
    } catch (_) {
      // ignore listener errors
    }
  }
}

export const toast = {
  subscribe(cb) {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },
  show(message, options = {}) {
    emit({
      id: Date.now() + Math.random(),
      type: options.type || 'info',
      message,
      duration: options.duration || 3500,
    });
  },
  success(message, options = {}) {
    toast.show(message, { ...options, type: 'success' });
  },
  error(message, options = {}) {
    toast.show(message, { ...options, type: 'error' });
  },
  info(message, options = {}) {
    toast.show(message, { ...options, type: 'info' });
  },
};

export default toast;
